/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useState} from 'react';
// material
import {ColorPicker} from '@insticator/insticator-ui';
import SectionCard from '../../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// styles
import injectSheet from 'react-jss';
import styles from './colorconfig_styles';
import {DEFAULT_COLORS} from "../../../../../../../state/slices/engagement";
// helpers
export const colors = [
  {name: "background", label: 'Background'},
  {name: "primaryText", label: 'Primary Text'},
  {name: "secondaryText", label: 'Secondary Text'},
  {name: "branding", label: 'Branding'},
];


/* ========== ~~~~~~~~~~ COLOR CONFIGS ~~~~~~~~~~ ========== */
const ColorConfigs = injectSheet(styles)((props) => {
  const {
    handleResetColour,
    handleSetColour,
    config: {
      colorConfiguration = {}
    },
    defaultConfig: {
      colorConfiguration: defaultColorConfiguration = {}
    },
  } = props;

  const [isColorsValid, setColorsValid] = useState({
    background: true,
    primaryText: true,
    secondaryText: true,
    branding: true
  })

  const getColor = useCallback((colorName) => {
    const color = colorConfiguration[colorName] || DEFAULT_COLORS[colorName]
    return `#${color.replaceAll('#', '')}`
  }, [colorConfiguration])

  const validateColor = (isValid, name) => {
    setColorsValid({
      ...isColorsValid,
      [name]: isValid
    })
  }

  return (
    <div className={`colorconfig ${props.classes.colorconfig}`}>
      <SectionCard>
        <SectionGroup>
          <SectionGroupDescription
            title='Set custom colors'
            description='Customize your color scheme if you want to add personality to the comments.'
          />
          <div className={'colorpickercolumn'}>
            {colors.map(c => (
              <ColorPicker
                key={c.name}
                handleReset={() => handleResetColour(c.name)}
                valid={isColorsValid[c.name]}
                color={getColor(c.name)}
                savedColor={`#${defaultColorConfiguration[c.name].replaceAll('#', '')}`}
                label={c.label}
                processColorUpdate={(value) => handleSetColour(c.name, value)}
                validateColor={(isValid, e) => validateColor(isValid, c.name)} 
              />
            ))}
          </div>
        </SectionGroup>
      </SectionCard>
    </div>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ColorConfigs;

